import { navigateTo } from '#imports'
import { useRoute } from 'vue-router'

export function useFilters(scrollToTarget?: () => void) {
  const route = useRoute()

  async function resetFiltersValues() {
    scrollToTarget?.()

    return navigateTo({
      ...route,
      hash: route.hash,
      query: {
        ...route.query,
        backbox_grade_label__in: undefined,
        global_rate__gte: undefined,
        global_rate__lte: undefined,
        seller_public_id: undefined,
        with_attachments: undefined,
        locale: undefined,
      },
    })
  }

  return {
    resetFiltersValues,
  }
}
